import React from 'react'
import { EmptyState, EmptyStateProps } from './EmptyState'

export interface TableEmptyStateProps extends EmptyStateProps {
    children: string | JSX.Element | JSX.Element[]
}

export const TableEmptyState = ({ children, ...props }: TableEmptyStateProps): JSX.Element => {
    return (
        <tr>
            <td colSpan={999}>
                <EmptyState {...props}>{children}</EmptyState>
            </td>
        </tr>
    )
}
